import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../store";

interface ProgressBarProps {
    color: string;
    value: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ color, value }) => {
    const dark = useSelector((state: RootState) => state.user.dark_mode);

    return (
        <div
            className="progress mt-1"
            style={{
                height: "0.5rem",
                backgroundColor: dark ? "#374151" : "#b6b4b4",
                borderRadius: "9999px",
                overflow: "hidden",
            }}
        >
            <div
                className="progress-bar"
                role="progressbar"
                style={{
                    width: `${value}%`,
                    backgroundColor: color,
                }}
                aria-valuenow={value}
                aria-valuemin={0}
                aria-valuemax={100}
            ></div>
        </div>
    );
};

export default ProgressBar;
